<template>
  <div class="personalProdures">
    <div v-show="datalist.length" class="tree-child">
      <div v-for="(item, i) in datalist" :key="item.id" class="personalProdureItem">
        <div class="first-child flex-center" @click="expandItem(item.id)" :class="activeNames == item.id ? 'bordernone' : ''">
          <van-icon class="expandIcon" :name="activeNames == item.id ? require('../assets/images/replydown.png') : require('../assets/images/replyopen.png')" />
          <p class="tree-title">{{ item.title }}</p>
        </div>
        <div v-show="treeList.length > 0 && activeNames == item.id">
          <div v-for="two in treeList" :key="two.id" class="tree-contnt" ref="produre_list">
            <h4 class="flex-center">
              <van-icon class="tree-two-icon" :name="require('../assets/images/sendchoose.png')" />
              {{ two.title }}
            </h4>

            <div v-for="third in two.newlistArr" :key="third.id" class="tree-third">
              <div @click="shareList(third)" class="flex-center">
                <van-icon class="tree-third-icon" :name="require('../assets/images/sendnormal.png')" />
                <div class="tree-rig-flex">
                  <div class="third-img" style="display: flex">
                    <div class="flex-left" ref="loadImg">
                      <img v-lazy="third.url" v-show="third.url && third.msgType == 'image' && third.url !== ''" alt="" />
                      <img v-show="third.picUrl && third.msgType == 'link' && third.picUrl !== ''" alt="" v-lazy="third.picUrl" />
                      <img v-show="third.url && third.msgType == 'miniprogram' && third.url !== ''" alt="" v-lazy="third.url" />
                      <img v-show="third.msgType == 'link' && third.picUrl == ''" alt="" v-lazy="require('../assets/images/website.png')" />
                      <img v-show="third.msgType == 'file'" alt="" v-lazy="require('../assets/images/text.png')" />
                      <img v-show="third.msgType == 'video'" alt="" v-lazy="require('../assets/images/video.png')" />

                      <img v-show="third.msgType == 'text'" alt="" v-lazy="require('../assets/images/text.png')" />

                      <img v-show="third.msgType == 'miniprogram' && third.url === ''" alt="" v-lazy="require('../assets/images/mini.png')" />
                      <img v-show="third.msgType == 'image' && third.url == ''" alt="" v-lazy="require('../assets/images/img.png')" />
                    </div>

                    <div class="third-right">
                      <div v-if="third.msgType == 'text'" class="textMsgType">
                        <p ref="filename">
                          {{ third.content }}
                        </p>
                        <div @click="handleShowMoreClick()" class="blue-color">
                          {{ showMore ? "收起" : "展开" }}
                        </div>
                      </div>
                      <div v-else class="third-size">
                        <p>
                          {{ third.fileName }}
                        </p>
                        {{ third.size || 0 }}kb
                      </div>
                    </div>
                  </div>

                  <span
                    v-if="['image', 'video'].indexOf(third.msgType) > -1 || (third.msgType == 'file' && third.fileName.slice(third.fileName.lastIndexOf('.') - 1 + 2) == 'pdf')"
                    @click="previewFile($event, third)"
                    class="review-btn"
                    >预览</span
                  >
                </div>
              </div>
            </div>

            <div v-if="two.listtotal > 3">
              <p v-if="!expandTrue" @click="lookMore(two)" class="max-look">查看更多 <van-icon name="arrow-down"></van-icon></p>
              <p v-if="expandTrue" @click="closeList(two)" class="max-look">收起 <van-icon name="arrow-up"></van-icon></p>
            </div>
          </div>
        </div>
        <div v-show="activeNames == item.id && treeList.length == 0" class="empty_produre">
          <span>暂无话术</span>
        </div>
      </div>
    </div>
    <!-- 预览pdf -->
    <van-popup v-model="showPdf" position="bottom" closeable round class="popup-pdf" @closed="closePopup">
      <div class="detail-popup">
        <div id="pdf-detail"></div>
      </div>
    </van-popup>
    <!-- 预览图片，视频 -->
    <van-dialog v-model="showFile" :showConfirmButton="false" :closeOnClickOverlay="true" width="90%" @close="closeImg">
      <!-- :class="{ videoDialog: showType == 'video' }" -->
      <img v-if="showType == 'image'" :src="preFileUrl" />
      <video v-if="showType == 'video'" :autoplay="false" :src="preFileUrl" controls />
      <div class="btn">
        <span @click="shareList(detailObj)">
          <van-icon name="share" />
          分享</span
        >
        <span @click="closeImg">关闭</span>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import treeChild from "@/components/js/treeChild";
export default treeChild;
</script>
<style lang="less" scoped>
@import "css/personalProdure";
/deep/.van-dialog {
  min-width: 350px;
  max-height: 70%;
}
</style>
